import { render, staticRenderFns } from "./item-drawer.vue?vue&type=template&id=856bca98&scoped=true&"
import script from "./item-drawer.vue?vue&type=script&lang=js&"
export * from "./item-drawer.vue?vue&type=script&lang=js&"
import style0 from "./item-drawer.vue?vue&type=style&index=0&id=856bca98&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "856bca98",
  null
  
)

export default component.exports